module.exports = __webpack_public_path__ + "fonts/Catamaran-Medium.b7668eb8.woff";